import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal';
import { normalizeLineBreaks } from '../../../util/utils';

const BookSummaryModal = ({ onCloseModal, bookData }) => {
    return (
        <Modal header={'Book Summary'} footer={''} onClose={onCloseModal}>
            <p style={{ whiteSpace: 'pre-line' }}>
                {normalizeLineBreaks(bookData?.synopsis)}
            </p>
        </Modal>
    );
};

BookSummaryModal.propTypes = {
    onCloseModal: PropTypes.func.isRequired,
    bookData: PropTypes.shape({
        synopsis: PropTypes.string.isRequired,
    }).isRequired,
};

export default BookSummaryModal;
